import moment from 'moment-timezone/builds/moment-timezone-with-data'
import store from './store';
import * as VM from '@/viewModel'

export function JsonClone(item){
    return JSON.parse(JSON.stringify(item));
}

export function italyFixDateAndTime(value: any, time: string) : string {
    const date = new Date(value)

    const hour = parseInt(time.substring(0, 2));
    const minutes = parseInt(time.substring(3, 5));
    
    date.setHours(date.getHours() + hour);
    date.setMinutes(date.getMinutes() + minutes);

    return date.toISOString();
}

export function getUniversalISOStringDate(input: Date | string): string {
    const data: string = JSON.parse(JSON.stringify(input))

    const result = new Date(data)
    result.setMinutes(result.getMinutes() - result.getTimezoneOffset())

    return result.toISOString()
}

export function getUniversalDate(input: Date | string): Date {
    const dataOrString: Date | string = JSON.parse(JSON.stringify(input))
    let date: Date

    if (typeof dataOrString == typeof '') date = new Date(input)
    else date = dataOrString as Date

    date.setMinutes(date.getMinutes() + date.getTimezoneOffset())

    return date
}

export function getOneLetterWeekDays(
  language: string | null = null
): { key: number; value: string }[] {
  if (!language) {
    language = store.state.user.preferredCulture.substring(0, 2)
  }

  const firstDayOfWeek = 1 // Sempre Lunedì
  moment.locale(language, {
    week: {
      dow: firstDayOfWeek
    }
  })

  const weekdays = moment.weekdays(true)
  const weekFirstLetter = weekdays.map((day) => day.charAt(0).toUpperCase())

  const result: { key: number; value: string }[] = []

  for (let i = firstDayOfWeek; i < weekFirstLetter.length + firstDayOfWeek; i++)
    result.push({
      key: i == weekFirstLetter.length ? 0 : i,
      value: weekFirstLetter[i - firstDayOfWeek]
    })

  return result
}

export function getImageTypeFromUrl(url: string) {
  const ext = url.split('.').pop()?.toLowerCase() || ''

  if (['mp4', 'webm', 'mov'].includes(ext)) {
    return '/img/mediaType/video.svg'
  } else if (['mp3', 'wav', 'ogg'].includes(ext)) {
    return '/img/mediaType/audio.svg'
  }

  return ''
}

export function getTypeFromUrl(url: string) {
    const ext = url.split('.').pop()?.toLowerCase() || ''

    if (['mp4', 'webm', 'mov'].includes(ext)) {
        return VM.AttachmentType.Video
    } else if (['mp3', 'wav', 'ogg'].includes(ext)) {
        return VM.AttachmentType.Audio
    } else if (['txt', 'md', 'rtf'].includes(ext)) {
        return VM.AttachmentType.Testo
    }

    return VM.AttachmentType.Altro
}

export function getDisplayType(displayType: string | null | undefined, attachmentUrl: string) {
    // Use displayType from API if available, otherwise calculate from URL
    if (displayType) {
        return displayType.toLowerCase()
    }
    return getTypeFromUrl(attachmentUrl)
}

export function getIanaTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}

export function getIanaTimeZoneList(): string[] {
  return moment.tz.names()
}